import { useQueueWorkflowStore } from "@elixir/stores";
import CreateViewIntro from "../create-view-intro";
import { WORKFLOW_VIEW_POPUP_STATE } from "@elixir/types";
import ApplyFiltersView from "../apply-filters-view";
import NamingView from "../naming-view";
import ConfirmFiltersView from "../confirm-filters-view";
import CreateViewDrawer from "../create-view-drawer";
import ViewAllQueues from "../view-all-queues";
import EditFilters from "../edit-filters";

const WorkflowViewJourney = () => {
  const createViewPopupState = useQueueWorkflowStore(
    (state) => state.createViewPopupState
  );

  switch (createViewPopupState) {
    case WORKFLOW_VIEW_POPUP_STATE.APPLY_FILTERS:
      return (
        <CreateViewDrawer>
          <ApplyFiltersView />
        </CreateViewDrawer>
      );
    case WORKFLOW_VIEW_POPUP_STATE.INTRO:
      return <CreateViewIntro />;
    case WORKFLOW_VIEW_POPUP_STATE.VIEW_NAMING:
      return (
        <CreateViewDrawer>
          <NamingView />
        </CreateViewDrawer>
      );
    case WORKFLOW_VIEW_POPUP_STATE.CONFIRM_FILTERS:
      return (
        <CreateViewDrawer>
          <ConfirmFiltersView />
        </CreateViewDrawer>
      );
    case WORKFLOW_VIEW_POPUP_STATE.EDIT_FILTERS:
      return <EditFilters />;
    case WORKFLOW_VIEW_POPUP_STATE.VIEW_QUEUES:
      return <ViewAllQueues />;
  }
  return null;
};

export default WorkflowViewJourney;
